import { LoyaltyPointsExpirationRow } from './LoyaltyPointsExpirationRow';
import {
  LoyaltyPointsHistoryCtaButton,
  LoyaltyPointsHistoryCtaLink,
} from './LoyaltyPointsHistoryCta';
import { LoyaltyPointsHistoryEmptyState } from './LoyaltyPointsHistoryEmptyState';
import { LoyaltyPointsHistoryErrorState } from './LoyaltyPointsHistoryErrorState';
import { LoyaltyPointsHistoryHeader } from './LoyaltyPointsHistoryHeader';
import { LoyaltyPointsHistoryLogo } from './LoyaltyPointsHistoryLogo';
import { LoyaltyPointsHistoryRow } from './LoyaltyPointsHistoryRow';
import { LoyaltyPointsHistorySeeMoreCta } from './LoyaltyPointsHistorySeeMoreCta';

export const LoyaltyPointsHistory = {
  Header: LoyaltyPointsHistoryHeader,
  Logo: LoyaltyPointsHistoryLogo,
  ErrorState: LoyaltyPointsHistoryErrorState,
  Row: LoyaltyPointsHistoryRow,
  ExpirationRow: LoyaltyPointsExpirationRow,
  CtaButton: LoyaltyPointsHistoryCtaButton,
  CtaLink: LoyaltyPointsHistoryCtaLink,
  SeeMoreCta: LoyaltyPointsHistorySeeMoreCta,
  EmptyState: LoyaltyPointsHistoryEmptyState,
};
